<template>
    <div>
        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-checkbox-group
                    :options="form.vigilancia"
                    :validations="{required: true}"
                    label="Vigilância em saúde bucal"
                    text-field="nome"
                    v-model="model.vigilancia"
                    value-field="id"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col cols="12">
                <rkm-form-radio-group
                    v-model="model.necessidadeProteseInferiorSuperior"
                    class="mb-0"
                    label="Necessidade de prótese inferior/superior"
                >
                    <rkm-form-radio :value="true">Sim</rkm-form-radio>
                    <rkm-form-radio :value="false">Não</rkm-form-radio>
                    <rkm-form-radio :value="null">Não avaliado</rkm-form-radio>
                </rkm-form-radio-group>
            </rkm-col>
        </rkm-row>
    </div>
</template>

<script>
export default {
    props: {
        form: {type: Object, required: true},
        model: {type: Object, required: true},
    },
}
</script>
